import React from 'react'
import { CAN_TYPE } from "../config/settings/constant";
import routes from "../config/settings/routes";
import { usePathParam } from "../modules/hooks/route";
import ProtectBySession from "../components/Security/ProtectBySession";
import BrandLayout from "../components/Layouts/BrandLayout";
import { SummaryKpi } from '@carbon/icons-react'
import { Breadcrumb, BreadcrumbItem } from '@carbon/react'
import Navbar from "../containers/Navbar/Navbar.container";
import ManagementMenu from "../containers/ManagementMenu/ManagementMenu.container";
import Heading from "../components/Layouts/Heading";
import CanContainer from '../containers/Can/Dashboard/Can.container';
import AccessControl from '../components/Security/ProtectByGroup';


/**
 * The Records page.
 */
const Can = () => {
    const type = usePathParam('type').toUpperCase();

    const TypeTitle = type => {
        switch (type) {
            case CAN_TYPE.DASHBOARD:
                return 'Dashboard CAN'
        }
    };

    const getTooltipContent = type => {
        switch (type) {
            case CAN_TYPE.DASHBOARD:
                return 'Vista para la visualización de los parámetros delequipo en tiempo real'    
        }
    };

    const CanBreadcrumbs = () => {
        return (
            <Breadcrumb noTrailingSlash>
                <BreadcrumbItem>
                    <a href="/">Salar</a>
                </BreadcrumbItem>
                {CAN_TYPE[type] !== CAN_TYPE['CAN-INITIAL'] && <BreadcrumbItem isCurrentPage>{TypeTitle(type)}</BreadcrumbItem>}
            </Breadcrumb>
        )
    }

    const typeToComponentMap = {
        [CAN_TYPE.DASHBOARD]: CanContainer
    }
    const ComponentToRender = typeToComponentMap[type];
    console.log('cositas',typeToComponentMap[type]);
    

    return (
        <ProtectBySession rule={(hasSession, signedIn) => !!(hasSession && signedIn)}>
            <BrandLayout
                navbar={<Navbar managementMenu={<ManagementMenu current={routes.can} />} />}
                header={<Heading title={TypeTitle(type)} icon={<SummaryKpi size={50} />} breadcrumbs={<CanBreadcrumbs />} tooltipContent={getTooltipContent(type)} />}
            >
                <AccessControl type={type}>
                    {ComponentToRender ? <ComponentToRender /> : <div>Component not found</div>}
                </AccessControl>
            </BrandLayout>
        </ProtectBySession>
    )
}

export default Can